"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.producerStatus = exports.producerBusinessType = exports.policyholderHasWriteAccess = exports.isUserExpired = exports.isPolicyholder = exports.isPilotAgent = exports.isMyProfileEnabled = exports.isLoadingSessionClaims = exports.isImpersonatingAnotherAgent = exports.isImpersonatingAPolicyholder = exports.isHomeAgent = exports.isEmployeeAuthentication = exports.isCancelledAgent = exports.isAuthorizedForUfgAgent = exports.isAgentIn109015AgencyCode = exports.isAgencyAdministrator = exports.hasSessionClaims = exports.hasServiceCenterAccess = exports.hasRequiredMigrationStatus = exports.hasMercerPortalLink = exports.hasAgencyProductionReportsAccess = exports.hasAgencyClaimReportsAccess = exports.hasAgencyAccountingReportsAccess = exports.getSuretyUnderwriterUsername = exports.getSessionClaims = exports.getProductionUnderwriterUsername = exports.getPersonalUnderwriterUsername = exports.getMercerAgentCode = exports.getMarketingRepresentativeUsername = exports.getLogoutUser = exports.getLegacySSOAuthenticationToken = exports.getLastPasswordChangeDate = exports.getLastLoginDate = exports.getIsPnCAgent = exports.getHasUfgAgentAccess = exports.getHasMarketingSolutionsAccess = exports.getHasBrokerAccess = exports.getFullstoryUserId = exports.getFirstName = exports.getFirstAndLastName = exports.getEmployeeUserName = exports.getEmployeePhotoUfgComRelativeUrl = exports.getEmployeeBranch = exports.getEmployee = exports.getEmail = exports.getCommercialUnderWriterUsername = exports.getClaimValue = exports.getApplicationId = exports.getAgentUserId = exports.getAgentProducerCode = exports.getAgentCode = exports.getAgencyContractBranchCode = exports.getAgencies = exports.getActiveAgencyState = exports.getActiveAgencyName = exports.getActiveAgencyCode = exports.getActiveAgency = exports.claimKeys = exports.canImpersonate = exports.agencyHasSuretyContract = exports.agencyHasPersonalLinesContract = exports.agencyHasCommercialLinesContract = exports.agencyAcceptsSuretyNewBusiness = exports.agencyAcceptsPersonalLinesNewBusiness = exports.agencyAcceptsCommercialLinesNewBusiness = exports.POLICYHOLDER_ROLE_POLICYHOLDER = exports.POLICYHOLDER_ROLE_IMPERSONATION_READONLY = exports.POLICYHOLDER_ROLE_IMPERSONATION_ADMIN = void 0;
var isUserExpired = exports.isUserExpired = function isUserExpired(state) {
  return state && state.ssoSession && state.ssoSession.userExpired;
};
var getLogoutUser = exports.getLogoutUser = function getLogoutUser(state) {
  return state && state.ssoSession && state.ssoSession.logoutUser;
};
var getSessionClaims = exports.getSessionClaims = function getSessionClaims(state) {
  return state && state.ssoSession && state.ssoSession.session && state.ssoSession.session.claims;
};
var hasSessionClaims = exports.hasSessionClaims = function hasSessionClaims(state) {
  return state && state.ssoSession && state.ssoSession.session && state.ssoSession.session.claims && state.ssoSession.session.claims.length > 0;
};
var isLoadingSessionClaims = exports.isLoadingSessionClaims = function isLoadingSessionClaims(state) {
  return state && state.ssoSession && state.ssoSession.isLoading;
};
var getClaimValue = exports.getClaimValue = function getClaimValue(claims, key) {
  var found = claims && claims.find(function (claim) {
    return claim.hasOwnProperty(key);
  });
  return found && found[key];
};
var getFirstName = exports.getFirstName = function getFirstName(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.firstName);
};
var getFirstAndLastName = exports.getFirstAndLastName = function getFirstAndLastName(state) {
  var sessionClaims = getSessionClaims(state);
  return "".concat(getClaimValue(sessionClaims, claimKeys.firstName), " ").concat(getClaimValue(sessionClaims, claimKeys.lastName));
};
var getEmail = exports.getEmail = function getEmail(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.email);
};
var getAgentCode = exports.getAgentCode = function getAgentCode(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agentCode);
};
var getActiveAgencyCode = exports.getActiveAgencyCode = function getActiveAgencyCode(state) {
  var sessionClaims = getSessionClaims(state);
  var agency = getClaimValue(sessionClaims, claimKeys.activeAgency);
  return agency && agency.agencyCode;
};
var getActiveAgency = exports.getActiveAgency = function getActiveAgency(state) {
  var sessionClaims = getSessionClaims(state);
  var agency = getClaimValue(sessionClaims, claimKeys.activeAgency);
  return agency;
};
var getActiveAgencyState = exports.getActiveAgencyState = function getActiveAgencyState(state) {
  var sessionClaims = getSessionClaims(state);
  var agency = getClaimValue(sessionClaims, claimKeys.activeAgency);
  return agency && agency.state;
};
var getActiveAgencyName = exports.getActiveAgencyName = function getActiveAgencyName(state) {
  var sessionClaims = getSessionClaims(state);
  var agency = getClaimValue(sessionClaims, claimKeys.activeAgency);
  return agency && agency.name;
};
var getAgencyContractBranchCode = exports.getAgencyContractBranchCode = function getAgencyContractBranchCode(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyContractBranchCode);
};
var getAgencies = exports.getAgencies = function getAgencies(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.associatedAgencies);
};
var getApplicationId = exports.getApplicationId = function getApplicationId(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.applicationId);
};
var getHasUfgAgentAccess = exports.getHasUfgAgentAccess = function getHasUfgAgentAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasUfgAgentAccess);
};
var getHasBrokerAccess = exports.getHasBrokerAccess = function getHasBrokerAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasBrokerAccess);
};
var getHasMarketingSolutionsAccess = exports.getHasMarketingSolutionsAccess = function getHasMarketingSolutionsAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasMarketingSolutionsAccess);
};
var getIsPnCAgent = exports.getIsPnCAgent = function getIsPnCAgent(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.isPnCAgent);
};
var isAuthorizedForUfgAgent = exports.isAuthorizedForUfgAgent = function isAuthorizedForUfgAgent(state, specialtyEnabled) {
  return !!specialtyEnabled ? getIsPnCAgent(state) && getHasUfgAgentAccess(state) || getHasBrokerAccess(state) : getIsPnCAgent(state) && getHasUfgAgentAccess(state);
};
var getEmployee = exports.getEmployee = function getEmployee(state) {
  var sessionClaims = getSessionClaims(state);
  var employee = getClaimValue(sessionClaims, claimKeys.employee);
  return employee;
};
var isMyProfileEnabled = exports.isMyProfileEnabled = function isMyProfileEnabled(state) {
  var agentCode = getAgentCode(state);
  //109015 is default employee agent account that should not have access to modify my profile as the agent account is shared for employees
  return !isImpersonatingAnotherAgent(state) && agentCode !== "1090151005";
};
var isAgencyAdministrator = exports.isAgencyAdministrator = function isAgencyAdministrator(state) {
  var sessionClaims = getSessionClaims(state);
  return !!getClaimValue(sessionClaims, claimKeys.isAgencyAdministrator);
};
var isEmployeeAuthentication = exports.isEmployeeAuthentication = function isEmployeeAuthentication(state) {
  return !!getEmployee(state);
};
var getMercerAgentCode = exports.getMercerAgentCode = function getMercerAgentCode(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.mercerAgentCode);
};
var isAgentIn109015AgencyCode = exports.isAgentIn109015AgencyCode = function isAgentIn109015AgencyCode(state) {
  var activeAgencyCode = getActiveAgencyCode(state);
  return activeAgencyCode === "109015";
};
var isHomeAgent = exports.isHomeAgent = function isHomeAgent(state) {
  var sessionClaims = getSessionClaims(state);
  return !!getClaimValue(sessionClaims, claimKeys.isHomeAgent);
};
var hasMercerPortalLink = exports.hasMercerPortalLink = function hasMercerPortalLink(state) {
  return !!getMercerAgentCode(state) || isAgentIn109015AgencyCode(state);
};
var canImpersonate = exports.canImpersonate = function canImpersonate(state) {
  var employee = getEmployee(state);
  return employee && employee.allowImpersonation;
};
var isImpersonatingAnotherAgent = exports.isImpersonatingAnotherAgent = function isImpersonatingAnotherAgent(state) {
  var agentCode = getAgentCode(state);
  var agentUserId = getAgentUserId(state);
  var employee = getEmployee(state);
  var isNotImpersonatingAnotherAgent = !employee || employee.employeeAgentId && agentCode === employee.employeeAgentId || employee.employeeAgentId && agentUserId === employee.employeeAgentId || employee.netLogin && agentUserId && agentUserId.toLowerCase() === employee.netLogin.toLowerCase() || employee.employeeEmail && agentUserId && agentUserId.toLowerCase() === employee.employeeEmail.toLowerCase();
  return !isNotImpersonatingAnotherAgent;
};
var getEmployeeUserName = exports.getEmployeeUserName = function getEmployeeUserName(state) {
  var employee = getEmployee(state);
  var hasNetLogin = employee && employee.netLogin;
  return hasNetLogin ? employee.netLogin : "";
};
var getEmployeePhotoUfgComRelativeUrl = exports.getEmployeePhotoUfgComRelativeUrl = function getEmployeePhotoUfgComRelativeUrl(state) {
  var employee = getEmployee(state);
  var hasEmployeePhotoId = employee && employee.employeePhotoId;
  return hasEmployeePhotoId ? "/AgentsOnly/Mugs/".concat(employee.employeePhotoId, ".jpg") : "";
};
var getEmployeeBranch = exports.getEmployeeBranch = function getEmployeeBranch(state) {
  var employee = getEmployee(state);
  var hasEmployeeBranch = employee && employee.employeeBranch;
  return hasEmployeeBranch ? employee.employeeBranch : "";
};
var getAgentUserId = exports.getAgentUserId = function getAgentUserId(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.userId);
};
var getAgentProducerCode = exports.getAgentProducerCode = function getAgentProducerCode(state) {
  var agentCode = getAgentCode(state);
  return agentCode && agentCode.length >= 4 ? agentCode.slice(-4) : "";
};
var getCommercialUnderWriterUsername = exports.getCommercialUnderWriterUsername = function getCommercialUnderWriterUsername(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.commercialUnderWriterUsername);
};
var getPersonalUnderwriterUsername = exports.getPersonalUnderwriterUsername = function getPersonalUnderwriterUsername(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.personalUnderwriterUsername);
};
var getSuretyUnderwriterUsername = exports.getSuretyUnderwriterUsername = function getSuretyUnderwriterUsername(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.suretyUnderwriterUsername);
};
var getProductionUnderwriterUsername = exports.getProductionUnderwriterUsername = function getProductionUnderwriterUsername(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.productionUnderwriterUsername);
};
var getMarketingRepresentativeUsername = exports.getMarketingRepresentativeUsername = function getMarketingRepresentativeUsername(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.marketingRepresentativeUsername);
};
var hasAgencyAccountingReportsAccess = exports.hasAgencyAccountingReportsAccess = function hasAgencyAccountingReportsAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasAgencyAccountingReportsAccess);
};
var hasAgencyProductionReportsAccess = exports.hasAgencyProductionReportsAccess = function hasAgencyProductionReportsAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasAgencyProductionReportsAccess);
};
var hasAgencyClaimReportsAccess = exports.hasAgencyClaimReportsAccess = function hasAgencyClaimReportsAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasAgencyClaimReportsAccess);
};
var hasServiceCenterAccess = exports.hasServiceCenterAccess = function hasServiceCenterAccess(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.hasServiceCenterAccess);
};
var getLegacySSOAuthenticationToken = exports.getLegacySSOAuthenticationToken = function getLegacySSOAuthenticationToken(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.authenticationToken);
};
var getFullstoryUserId = exports.getFullstoryUserId = function getFullstoryUserId(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.fullStoryUserId);
};
var isPolicyholder = exports.isPolicyholder = function isPolicyholder(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.isPolicyholder);
};
var isPilotAgent = exports.isPilotAgent = function isPilotAgent(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.isPilotAgent);
};
var isImpersonatingAPolicyholder = exports.isImpersonatingAPolicyholder = function isImpersonatingAPolicyholder(state) {
  var sessionClaims = getSessionClaims(state);
  var policyholderRole = getClaimValue(sessionClaims, claimKeys.policyholderRole);
  return policyholderRole === POLICYHOLDER_ROLE_IMPERSONATION_ADMIN || policyholderRole === POLICYHOLDER_ROLE_IMPERSONATION_READONLY;
};
var policyholderHasWriteAccess = exports.policyholderHasWriteAccess = function policyholderHasWriteAccess(state) {
  var sessionClaims = getSessionClaims(state);
  var policyholderRole = getClaimValue(sessionClaims, claimKeys.policyholderRole);
  return policyholderRole === POLICYHOLDER_ROLE_POLICYHOLDER || policyholderRole === POLICYHOLDER_ROLE_IMPERSONATION_ADMIN;
};
var hasRequiredMigrationStatus = exports.hasRequiredMigrationStatus = function hasRequiredMigrationStatus(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.policyholderMigrationStatus) === 1;
};
var getLastLoginDate = exports.getLastLoginDate = function getLastLoginDate(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.lastLogin);
};
var agencyHasCommercialLinesContract = exports.agencyHasCommercialLinesContract = function agencyHasCommercialLinesContract(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyHasCommercialLinesContract);
};
var agencyHasPersonalLinesContract = exports.agencyHasPersonalLinesContract = function agencyHasPersonalLinesContract(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyHasPersonalLinesContract);
};
var agencyHasSuretyContract = exports.agencyHasSuretyContract = function agencyHasSuretyContract(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyHasSuretyContract);
};
var agencyAcceptsCommercialLinesNewBusiness = exports.agencyAcceptsCommercialLinesNewBusiness = function agencyAcceptsCommercialLinesNewBusiness(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyAcceptsCommercialLinesNewBusiness);
};
var agencyAcceptsPersonalLinesNewBusiness = exports.agencyAcceptsPersonalLinesNewBusiness = function agencyAcceptsPersonalLinesNewBusiness(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyAcceptsPersonalLinesNewBusiness);
};
var agencyAcceptsSuretyNewBusiness = exports.agencyAcceptsSuretyNewBusiness = function agencyAcceptsSuretyNewBusiness(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyAcceptsSuretyNewBusiness);
};
var producerBusinessType = exports.producerBusinessType = function producerBusinessType(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.producerBusinessType);
};
var producerStatus = exports.producerStatus = function producerStatus(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.producerStatus);
};
var isCancelledAgent = exports.isCancelledAgent = function isCancelledAgent(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.agencyStatus) === "C";
};
var getLastPasswordChangeDate = exports.getLastPasswordChangeDate = function getLastPasswordChangeDate(state) {
  var sessionClaims = getSessionClaims(state);
  return getClaimValue(sessionClaims, claimKeys.lastPasswordChange);
};
var POLICYHOLDER_ROLE_POLICYHOLDER = exports.POLICYHOLDER_ROLE_POLICYHOLDER = "Policyholder";
var POLICYHOLDER_ROLE_IMPERSONATION_ADMIN = exports.POLICYHOLDER_ROLE_IMPERSONATION_ADMIN = "PolicyholderImpersonationAdmin";
var POLICYHOLDER_ROLE_IMPERSONATION_READONLY = exports.POLICYHOLDER_ROLE_IMPERSONATION_READONLY = "PolicyholderImpersonationReadonly";
var claimKeys = exports.claimKeys = {
  authenticationToken: "SSO.AuthenticationToken",
  fullStoryUserId: "SSO.FullStory.UserId",
  applicationId: "SSO.ApplicationId",
  ssoSessionExpiration: "SSO.ExpirationDate",
  employee: "SSO.Employee.Identity",
  lastLogin: "SSO.LastLoginDate",
  userId: "SSO.UserId",
  email: "SSO.Email",
  associatedAgencies: "SSO.Agent.Agencies",
  firstName: "SSO.FirstName",
  lastName: "SSO.LastName",
  agentCode: "SSO.Agent.AgentCode",
  activeAgency: "SSO.Agent.ActiveAgency",
  hasMarketingSolutionsAccess: "SSO.Agent.HasMarketingSolutionsAccess",
  hasUfgAgentAccess: "SSO.Agent.HasUfgAgentAccess",
  hasBrokerAccess: "SSO.Agent.HasWholeSaleBrokerAccess",
  isAgencyAdministrator: "SSO.Agent.IsAgencyAdministrator",
  isHomeAgent: "SSO.Agent.IsHomeAgent",
  isPnCAgent: "SSO.IsPropertyAndCasualtyAgent",
  isTemporaryID: "SSO.Agent.IsTemporaryId",
  mercerAgentCode: "SSO.Agent.MercerAgentCode",
  commercialUnderWriterUsername: "SSO.Agent.CommercialUnderwriterUsername",
  personalUnderwriterUsername: "SSO.Agent.PersonalUnderwriterUsername",
  suretyUnderwriterUsername: "SSO.Agent.SuretyUnderwriterUsername",
  productionUnderwriterUsername: "SSO.Agent.ProductionUnderwriterUsername",
  marketingRepresentativeUsername: "SSO.Agent.MarketingRepresentativeUsername",
  hasAgencyAccountingReportsAccess: "SSO.Agent.HasAgencyAccountingReportsAccess",
  hasAgencyProductionReportsAccess: "SSO.Agent.HasAgencyProductionReportsAccess",
  hasAgencyClaimReportsAccess: "SSO.Agent.HasAgencyClaimReportsAccess",
  isPolicyholder: "SSO.IsPolicyholder",
  policyholderMigrationStatus: "SSO.Policyholder.MigrationStatus",
  policyholderRole: "SSO.Policyholder.Role",
  hasServiceCenterAccess: "SSO.Agent.ProducerHasServiceCenterAccess",
  isPilotAgent: "SSO.Agent.IsPilotAgent",
  agencyHasCommercialLinesContract: "SSO.Agent.AgencyHasCommercialLinesContract",
  agencyHasPersonalLinesContract: "SSO.Agent.AgencyHasPersonalLinesContract",
  agencyHasSuretyContract: "SSO.Agent.AgencyHasSuretyContract",
  agencyAcceptsCommercialLinesNewBusiness: "SSO.Agent.AgencyAcceptsCommercialLinesNewBusiness",
  agencyAcceptsPersonalLinesNewBusiness: "SSO.Agent.AgencyAcceptsPersonalLinesNewBusiness",
  agencyAcceptsSuretyNewBusiness: "SSO.Agent.AgencyAcceptsSuretyNewBusiness",
  producerBusinessType: "SSO.Agent.ProducerBusinessType",
  producerStatus: "SSO.Agent.ProducerStatus",
  agencyStatus: "SSO.Agent.AgencyStatus",
  agencyContractBranchCode: "SSO.Agent.AgencyContractBranchCode",
  lastPasswordChange: "SSO.LastPasswordChangeDate"
};